import React, { useEffect, createContext, useState} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MdAdminPanelSettings, MdBugReport, MdLogout } from "react-icons/md";


import "../css/wrarper.css";

const FloatTools = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [logined, setLogined] = useState(false);
    const [admin, setAdmin] = useState(false);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.reload();
    };

    useEffect(() => {
        const getData = async () => {
            const token = localStorage.getItem("token");
            if (token) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/fltools`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                });

                if (response.ok) {
                    const data = await response.json();
                    if (!data.valid) {
                        // Token is invalid or expired
                    }
                    setLogined(data.login);
                    setAdmin(data.admin);
                } else {
                    // Handle invalid response
                    localStorage.removeItem("token");
                    window.location.reload();
                }
            } catch (error) {
                console.error("Error validating token:", error);
                localStorage.removeItem("token");
                window.location.reload();
            }
            } else {
            }
        };

        getData();
    }, [location.pathname, navigate]);

  
  return (
    <>
        <div className="floating-tool">
            
            <a href="/form">
                <div className="floating-btn"><MdBugReport />문의 또는 신고</div>
            </a>
            {logined && (
                <>
                    <div className="floating-btn" onClick={handleLogout}><MdLogout />로그아웃</div>

                    {admin && (
                    <a href="/admin">
                        <div className="floating-btn"><MdAdminPanelSettings />관리자 도구</div>
                    </a>
                    )}
                </>
            )}
        </div>
    </>
  );
};

export default FloatTools;
